import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";

const ModalContent1 = () => {
  return (
    <div className="row align-items-center">
      <div className="col-xs col-sm-3 col-md-3 col-lg-3">
        <div
          id="svgImage"
          style={{
            borderRadius: "50%",
            height: "160px",
            width: "160px",
            padding: "2rem",
          }}
        >
          <figure>
            <svg
              stroke="white"
              stroke-width="0.2"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
              width="75.502"
              height="80.035"
              viewBox="0 0 75.502 80.035"
            >
              <g id="real-estate-agent" transform="translate(-13.741 0.807)">
                <g
                  id="Group_88"
                  data-name="Group 88"
                  transform="translate(13.741 -0.807)"
                >
                  <path
                    id="Path_107"
                    data-name="Path 107"
                    d="M87.82,59.362a1.172,1.172,0,0,0-2.009,1.209,12.921,12.921,0,0,1,1.846,6.665V77.689H49.671V63.026a3.507,3.507,0,0,0,1.169.2h0a3.517,3.517,0,0,0,1.747-6.571l-2.014-1.151a12.923,12.923,0,0,1,3.73-1.095c.657,2.518,2.12,6.635,4.811,7.578a4.776,4.776,0,0,0,1.592.27,7.672,7.672,0,0,0,4.673-1.993,7.67,7.67,0,0,0,4.674,1.993,4.784,4.784,0,0,0,1.592-.27c2.691-.944,4.154-5.062,4.811-7.579a12.853,12.853,0,0,1,6,2.453,1.172,1.172,0,0,0,1.4-1.878,15.192,15.192,0,0,0-8-2.993,2.24,2.24,0,0,0-.281-.226l-4.34-2.943V47.347a16.341,16.341,0,0,0,10-11.634,4.792,4.792,0,0,0,1.8.352c3.447,0,5.251-3.912,5.251-7.777,0-3.438-1.366-5.886-3.594-6.677a12.32,12.32,0,0,0,.356-6.64c1.146-2.348,1.318-4.455.512-6.27a7.32,7.32,0,0,0-3.835-3.532,5.134,5.134,0,0,0-.909-3.638C80.378.872,79.02-1.131,66.98.851a1.172,1.172,0,1,0,.381,2.314c8.364-1.377,11.15-.694,11.528-.31a2.661,2.661,0,0,1,.39,2.518,1.133,1.133,0,0,0-.041,1.01,1.163,1.163,0,0,0,.8.656c.025.006,2.535.693,3.389,2.614.543,1.222.33,2.77-.635,4.6a1.171,1.171,0,0,0-.11.786c.7,3.377.111,5.426-.7,6.887l-.018.033a14.439,14.439,0,0,1-.972,1.469,8.113,8.113,0,0,0-.83,1.3,9.532,9.532,0,0,0-.564,2.042,7.773,7.773,0,0,1-1.332-1.409c.332-3.273.527-8.851-1.657-10.786a2.914,2.914,0,0,0-2.689-.641c-.947.217-1.768.422-2.493.6a22.328,22.328,0,0,1-6.182.942,22.33,22.33,0,0,1-6.182-.942c-.725-.18-1.546-.385-2.492-.6a2.914,2.914,0,0,0-2.689.641C51.7,16.513,51.9,22.113,52.231,25.383A7.262,7.262,0,0,1,51,26.8a13.843,13.843,0,0,0-.668-2.071c-.058-.124-.116-.246-.175-.368a8.461,8.461,0,0,1-.952-3.731,1.248,1.248,0,0,0-.019-.15,19.35,19.35,0,0,1,.112-6.758c.934-4.487,3.577-7.311,7.854-8.393,1.638-.414,3.272-.8,4.856-1.138A1.172,1.172,0,1,0,61.516,1.9c-1.612.347-3.273.736-4.938,1.157C51.419,4.358,48.106,7.892,47,13.274a21.651,21.651,0,0,0-.126,7.57c.013.193.029.375.046.552-2.729.423-4.449,3.033-4.449,6.891s1.8,7.777,5.251,7.777a4.792,4.792,0,0,0,1.788-.347A16.285,16.285,0,0,0,59.519,47.374v1.451l-4.34,2.943a2.254,2.254,0,0,0-.281.225,15.259,15.259,0,0,0-6.728,2.14l-12-6.855a3.531,3.531,0,0,0-3.49,0l-.6.343v-.667a1.8,1.8,0,0,0,1.563-1.781V41.735a1.8,1.8,0,0,0-1.8-1.8H20.6a1.8,1.8,0,0,0-1.8,1.8v3.439a1.8,1.8,0,0,0,1.563,1.781v7.366l-4.089,2.337a3.52,3.52,0,0,0,1.75,6.573,3.476,3.476,0,0,0,1.166-.2v4.958a1.172,1.172,0,1,0,2.345,0V61.753l12.9-7.369,12.9,7.369V77.689H42.342V63.854a1.8,1.8,0,0,0-1.8-1.8H28.351a1.8,1.8,0,0,0-1.8,1.8V77.689h-5.02v-3.4a1.172,1.172,0,0,0-2.345,0v4.575a1.172,1.172,0,0,0,1.172,1.172H88.829A1.172,1.172,0,0,0,90,78.861V67.236A15.268,15.268,0,0,0,87.82,59.362Zm-16.95.416c-1.282.449-2.677-.315-3.595-1a11.067,11.067,0,0,0,3.854-7.193l3.1,2.1c-.837,3.285-2.151,5.676-3.355,6.1ZM85.95,28.288c0,2.67-1.087,5.432-2.906,5.432a2.6,2.6,0,0,1-1.45-.464c.024-.358.037-.719.037-1.084V29.055a16.1,16.1,0,0,1,.659-3.339,6.847,6.847,0,0,1,.6-.909c.226-.312.481-.662.738-1.062,1.7.4,2.322,2.531,2.322,4.543ZM47.719,33.72c-1.819,0-2.906-2.762-2.906-5.432,0-2.1.677-4.33,2.545-4.584a11.548,11.548,0,0,0,.687,1.67c.055.114.109.227.162.341a23.054,23.054,0,0,1,.925,3.384v3.13c0,.345.012.688.033,1.03a2.6,2.6,0,0,1-1.446.462Zm3.758-1.491v-2.7c3.259-2.72,3.142-3.859,3.1-4.243-.464-4.412-.109-8.1.863-8.956a.592.592,0,0,1,.609-.11c.925.212,1.735.414,2.45.592a24.768,24.768,0,0,0,6.749,1.012A24.767,24.767,0,0,0,72,16.811c.715-.178,1.525-.38,2.45-.592a.592.592,0,0,1,.609.11c.972.861,1.327,4.544.862,8.956-.041.391-.16,1.549,3.368,4.279v2.608A13.949,13.949,0,0,1,65.353,46.105,13.878,13.878,0,0,1,51.476,32.229ZM65.353,48.45a16.27,16.27,0,0,0,3.545-.39v2.2a9.067,9.067,0,0,1-3.518,7,8.958,8.958,0,0,1-3.517-6.921V48.075A16.356,16.356,0,0,0,65.353,48.45Zm-5.721,3.131a11.068,11.068,0,0,0,3.854,7.193c-.918.69-2.313,1.453-3.595,1-1.2-.422-2.518-2.813-3.354-6.1Zm-38.49-9.3H31.3v2.345H21.142Zm1.563,4.69H29.74v1.99l-7.034,4.02Zm11.142,5.044L19.806,60.039l-.013.007-1.195.683a1.172,1.172,0,0,1-1.163-2.036l16.414-9.379a1.177,1.177,0,0,1,1.163,0l16.413,9.379a1.173,1.173,0,0,1-.584,2.19,1.154,1.154,0,0,1-.579-.155l-1.194-.682-.014-.008L35.012,52.015a1.173,1.173,0,0,0-1.163,0ZM28.9,77.689V64.4H40V77.689Z"
                    transform="translate(-14.5 0.002)"
                  />
                  <path
                    id="Path_108"
                    data-name="Path 108"
                    d="M316.5,421.852a3.673,3.673,0,1,0,3.673-3.673A3.678,3.678,0,0,0,316.5,421.852Zm5,0a1.329,1.329,0,1,1-1.329-1.329A1.33,1.33,0,0,1,321.5,421.852Z"
                    transform="translate(-269.289 -352.81)"
                  />
                  <path
                    id="Path_109"
                    data-name="Path 109"
                    d="M327.372,218.7a4.255,4.255,0,0,0,2.468,0,1.172,1.172,0,0,0-.592-2.269,1.981,1.981,0,0,1-1.284,0,1.172,1.172,0,1,0-.592,2.269Z"
                    transform="translate(-277.725 -182.569)"
                  />
                  <path
                    id="Path_110"
                    data-name="Path 110"
                    d="M287.3,138.126a1.172,1.172,0,0,0,.592-2.269,7.881,7.881,0,0,0-4.627,0,1.172,1.172,0,1,0,.592,2.269,5.542,5.542,0,0,1,3.443,0Z"
                    transform="translate(-240.513 -114.327)"
                  />
                  <path
                    id="Path_111"
                    data-name="Path 111"
                    d="M358.259,138.126a5.542,5.542,0,0,1,3.443,0,1.172,1.172,0,0,0,.592-2.269,7.881,7.881,0,0,0-4.627,0,1.172,1.172,0,0,0,.592,2.269Z"
                    transform="translate(-303.284 -114.327)"
                  />
                  <path
                    id="Path_112"
                    data-name="Path 112"
                    d="M321.282,243.533a1.172,1.172,0,0,0-1.14-2.049,4.921,4.921,0,0,1-4.753,0,1.172,1.172,0,1,0-1.14,2.049,7.281,7.281,0,0,0,7.034,0Z"
                    transform="translate(-266.884 -203.61)"
                  />
                  <path
                    id="Path_113"
                    data-name="Path 113"
                    d="M291.669,172.418a1.172,1.172,0,0,0-1.172,1.172v.938a1.172,1.172,0,1,0,2.345,0v-.938A1.172,1.172,0,0,0,291.669,172.418Z"
                    transform="translate(-247.354 -145.466)"
                  />
                  <path
                    id="Path_114"
                    data-name="Path 114"
                    d="M375.67,172.418a1.172,1.172,0,0,0-1.172,1.172v.938a1.172,1.172,0,1,0,2.345,0v-.938A1.172,1.172,0,0,0,375.67,172.418Z"
                    transform="translate(-318.224 -145.466)"
                  />
                </g>
              </g>
            </svg>
          </figure>
        </div>
      </div>
      <div className="col-xs col-sm-9 col-md-9 col-lg-9">
        <div className="px-4">
          <h3>Real Estate Agent/REALTOR® </h3>
          <p>
            REALTORS® or real estate agents can use RE-Sure as their “go-to” and
            all in one platform. Create contracts at lightning speed, store
            customer data, contract templates and customize contracts for any
            agent to perform due diligence quickly and on the go. In addition,
            search properties and retrieve MLS information to be an immediate
            source of information for your clients.
          </p>
        </div>
      </div>
    </div>
  );
};
const ModalContent2 = () => {
  return (
    <div className="row align-items-center">
      <div className="col-xs col-sm-3 col-md-3 col-lg-3">
        <div
          id="svgImage"
          style={{
            borderRadius: "50%",
            height: "160px",
            width: "160px",
            padding: "2.5rem 2.5rem 2.5rem 2.5rem",
          }}
        >
          <figure>
            <svg
              stroke="white"
              stroke-width="0.2"
              fill="white"
              id="value"
              xmlns="http://www.w3.org/2000/svg"
              width="79.888"
              height="79.928"
              viewBox="0 0 79.888 79.928"
            >
              <path
                id="Path_47"
                data-name="Path 47"
                d="M96.035,285.438l-.41.221a5.654,5.654,0,0,0-6.718-1.682l-.023.012-.969.522a7.357,7.357,0,0,0-8.425-.761l-5.217,2.837H67.332a10.028,10.028,0,0,1-4.34-.995l-.955-.462a16.382,16.382,0,0,0-17.049,1.665c-.023.017-.045.035-.066.054L42.616,288.9a8,8,0,0,1-3.018,1.682l-1.309-4.3a1.038,1.038,0,0,0-.993-.735H26.146a1.038,1.038,0,0,0-1.03,1.164l3.717,30.475a1.038,1.038,0,0,0,1.03.912H46.587a1.038,1.038,0,0,0,.993-1.341l-2.2-7.21,6.843-4.325a4.118,4.118,0,0,1,3-.389l.065.014,13.919,2.563a18.012,18.012,0,0,0,11.13-1.572,1.011,1.011,0,0,0,.127-.074l24.075-16.53a1.038,1.038,0,0,0,.3-1.391A6.608,6.608,0,0,0,96.035,285.438Zm-6.179.385a3.545,3.545,0,0,1,3.876.857L84.6,291.605l-.536.282a7.916,7.916,0,0,0-1.25-2.272Zm-9.361-.257.025-.014a5.279,5.279,0,0,1,5.369.05l-4.642,2.5a7.887,7.887,0,0,0-2.965-1.334ZM30.781,316.025l-3.463-28.4h9.208l8.658,28.4Zm48.575-12.011a15.922,15.922,0,0,1-9.771,1.358L55.7,302.815a6.189,6.189,0,0,0-4.513.612l-.048.029-6.386,4.037L40.2,292.571a10.081,10.081,0,0,0,3.792-2.12l2.273-2.024A14.313,14.313,0,0,1,61.132,287l.955.462a12.116,12.116,0,0,0,5.244,1.2h9.26a5.856,5.856,0,0,1,5.743,4.756l-6.711-.3a40.19,40.19,0,0,0-7.3.338,1.038,1.038,0,1,0,.285,2.056,38.054,38.054,0,0,1,6.925-.32l7.9.357h.047a1.038,1.038,0,0,0,1.038-1.038c0-.168-.007-.334-.017-.5l1.083-.571,11.444-6.172a4.535,4.535,0,0,1,5.457.875Z"
                transform="translate(-25.108 -238.173)"
              />
              <path
                id="Path_48"
                data-name="Path 48"
                d="M76.974,434.566a3.268,3.268,0,1,0,3.268-3.268A3.268,3.268,0,0,0,76.974,434.566Zm3.268-1.192a1.192,1.192,0,1,1-1.192,1.192,1.192,1.192,0,0,1,1.192-1.192Z"
                transform="translate(-68.001 -361.008)"
              />
              <path
                id="Path_49"
                data-name="Path 49"
                d="M226.292,36.288v-3.42a7.879,7.879,0,1,0-15.758,0v3.42a7.879,7.879,0,1,0,15.758,0Zm-13.682,0v-3.42a5.8,5.8,0,1,1,11.606,0v3.42a5.8,5.8,0,1,1-11.606,0Z"
                transform="translate(-178.456 -24.989)"
              />
              <path
                id="Path_50"
                data-name="Path 50"
                d="M89.491,159.567h25.4a1.038,1.038,0,0,0,1.038-1.038v-2.383h17.388a1.038,1.038,0,0,0,1.038-1.038v-6.737a7.78,7.78,0,0,0-7.285-7.76A1.212,1.212,0,0,0,126,141.2a4.763,4.763,0,0,1-7.515-.184,1.038,1.038,0,0,0-.861-.421,7.7,7.7,0,0,0-3.818,1.114,8.726,8.726,0,0,0-6.09-3.02,1.262,1.262,0,0,0-1.07.623,5.589,5.589,0,0,1-8.819-.215,1.035,1.035,0,0,0-.861-.421,8.687,8.687,0,0,0-6.028,2.63c-.131.134-.256.273-.377.414a7.718,7.718,0,0,0-3.539-1.111,1.214,1.214,0,0,0-1.069.591,4.763,4.763,0,0,1-7.515-.184,1.041,1.041,0,0,0-.861-.421A7.777,7.777,0,0,0,70,148.371v6.737a1.038,1.038,0,0,0,1.038,1.038H88.453v2.383A1.038,1.038,0,0,0,89.491,159.567Zm27.691-16.86a6.84,6.84,0,0,0,10.241.027,5.707,5.707,0,0,1,4.855,5.637v5.7h-16.35v-6.659a8.684,8.684,0,0,0-.959-3.974A5.61,5.61,0,0,1,117.182,142.707ZM96.52,140.786a7.666,7.666,0,0,0,11.579.027,6.667,6.667,0,0,1,5.754,6.6v10.079H90.529V147.411A6.706,6.706,0,0,1,96.52,140.786ZM72.076,154.07v-5.7a5.74,5.74,0,0,1,5.061-5.664,6.84,6.84,0,0,0,10.24.026,5.663,5.663,0,0,1,2.026.715,8.7,8.7,0,0,0-.949,3.963v6.659Z"
                transform="translate(-62.234 -119.01)"
              />
              <path
                id="Path_51"
                data-name="Path 51"
                d="M345.181,60.28V57.286a7.026,7.026,0,1,0-14.051,0V60.28a7.026,7.026,0,1,0,14.051,0Zm-11.976,0V57.286a4.95,4.95,0,0,1,9.9,0V60.28a4.95,4.95,0,0,1-9.9,0Z"
                transform="translate(-278.189 -45.888)"
              />
              <path
                id="Path_52"
                data-name="Path 52"
                d="M113.7,60.28V57.286a7.026,7.026,0,1,0-14.051,0V60.28a7.026,7.026,0,1,0,14.051,0Zm-11.976,0V57.286a4.95,4.95,0,0,1,9.9,0V60.28a4.95,4.95,0,0,1-9.9,0Z"
                transform="translate(-86.751 -45.888)"
              />
            </svg>
          </figure>
        </div>
      </div>
      <div className="col-xs col-sm-9 col-md-9 col-lg-9">
        <div className="px-4">
          <h3>Customer</h3>
          <p>
            Offer clients an opportunity to search properties, track their
            contracts and offers, connect to agents to ask a question, retrieve
            updated timelines, and be engaged completely in the transaction. As
            the agent or REALTOR, keep up-to-date on client information,
            requests and communication quickly, efficiently and correctly.
          </p>
        </div>
      </div>
    </div>
  );
};
const ModalContent3 = () => {
  return (
    <div className="row align-items-center">
      <div className="col-xs col-sm-3 col-md-3 col-lg-3">
        <div
          id="svgImage"
          style={{
            borderRadius: "50%",
            height: "160px",
            width: "160px",
            padding: "2.5rem 2.5rem 2.5rem 2.8rem",
          }}
        >
          <figure>
            <svg
              stroke="white"
              stroke-width="0.2"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
              width="79.766"
              height="79.766"
              viewBox="0 0 79.766 79.766"
            >
              <g id="XMLID_1248_" transform="translate(0 0)">
                <g id="XMLID_871_" transform="translate(0 0)">
                  <path
                    id="XMLID_874_"
                    d="M80.852,153.241h34.021a1.558,1.558,0,1,0,0-3.116H80.852a1.558,1.558,0,1,0,0,3.116Z"
                    transform="translate(-66.941 -126.737)"
                  />
                  <path
                    id="XMLID_887_"
                    d="M132.392,97.241h17.962a1.558,1.558,0,1,0,0-3.116H132.392a1.558,1.558,0,0,0,0,3.116Z"
                    transform="translate(-110.451 -79.461)"
                  />
                  <path
                    id="XMLID_917_"
                    d="M80.852,209.241h34.021a1.558,1.558,0,1,0,0-3.116H80.852a1.558,1.558,0,1,0,0,3.116Z"
                    transform="translate(-66.941 -174.012)"
                  />
                  <path
                    id="XMLID_919_"
                    d="M84.461,310.969a1.909,1.909,0,0,1,2.051,1.718,1.558,1.558,0,1,0,3.116,0,4.89,4.89,0,0,0-3.609-4.609v-.217a1.558,1.558,0,0,0-3.116,0v.217a4.89,4.89,0,0,0-3.61,4.609,5.015,5.015,0,0,0,5.167,4.834,1.745,1.745,0,1,1-2.052,1.718,1.558,1.558,0,1,0-3.116,0,4.89,4.89,0,0,0,3.61,4.609v.217a1.558,1.558,0,0,0,3.116,0v-.217a4.89,4.89,0,0,0,3.609-4.609,5.014,5.014,0,0,0-5.167-4.834,1.745,1.745,0,1,1,0-3.436Z"
                    transform="translate(-66.941 -258.584)"
                  />
                  <path
                    id="XMLID_920_"
                    d="M97.862,262.125H80.852a1.558,1.558,0,1,0,0,3.116h17.01a1.558,1.558,0,0,0,0-3.116Z"
                    transform="translate(-66.941 -221.288)"
                  />
                  <path
                    id="XMLID_1032_"
                    d="M79.309,53.626,61.382,35.7V1.558A1.558,1.558,0,0,0,59.824,0H1.558A1.558,1.558,0,0,0,0,1.558v76.65a1.558,1.558,0,0,0,1.558,1.558h73.6a1.558,1.558,0,0,0,1.558-1.558V56.286h1.495a1.558,1.558,0,0,0,1.1-2.66ZM3.116,3.116h55.15v29.5a1.555,1.555,0,0,0-1.988.178L35.45,53.626a1.558,1.558,0,0,0,1.1,2.66h1.5V76.65H3.116ZM51.927,76.65V63.141H62.832V76.65Zm21.67,0H65.948V61.583a1.558,1.558,0,0,0-1.558-1.558H50.369a1.558,1.558,0,0,0-1.558,1.558V76.65H41.162V56.286h9.207a1.558,1.558,0,1,0,0-3.116H40.312L57.379,36.1,74.446,53.17H64.39a1.558,1.558,0,0,0,0,3.116H73.6V76.65Z"
                    transform="translate(0 0)"
                  />
                  <path
                    id="XMLID_1035_"
                    d="M359.868,341.29a1.559,1.559,0,1,0,1.1.456A1.566,1.566,0,0,0,359.868,341.29Z"
                    transform="translate(-302.488 -288.12)"
                  />
                </g>
              </g>
            </svg>
          </figure>
        </div>
      </div>
      <div className="col-xs col-sm-9 col-md-9 col-lg-9">
        <div className="px-4">
          <h3>Mortgage Broker/Lender </h3>
          <p>
            As a party to a buy side transaction, a lender can be sure to have
            all the information needed in one place and make requests to buyers
            for documentation, loan status, etc.
          </p>
        </div>
      </div>
    </div>
  );
};
const ModalContent4 = () => {
  return (
    <div className="row align-items-center">
      <div className="col-xs col-sm-3 col-md-3 col-lg-3">
        <div
          id="svgImage"
          style={{
            borderRadius: "50%",
            height: "160px",
            width: "160px",
            padding: "2.5rem 2.5rem 2.5rem 2.8rem",
          }}
        >
          <figure>
            <svg
              stroke="white"
              stroke-width="0.2"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
              width="62.245"
              height="79.693"
              viewBox="0 0 62.245 79.693"
            >
              <path
                id="award"
                d="M35.875,79.693a1.128,1.128,0,0,1-.136-.008h-.012a1.044,1.044,0,0,1-.14-.027h0a1.145,1.145,0,0,1-.521-.3l0,0,0,0,0,0L19.407,63.28l0,0h0l0,0a1.142,1.142,0,0,1-.281-.5h0v0a.006.006,0,0,0,0,0,1.128,1.128,0,0,1-.03-.166h0V62.6h0a1.215,1.215,0,0,1-.006-.123V1.143A1.143,1.143,0,0,1,20.227,0H80.186a1.143,1.143,0,0,1,1.143,1.143V78.55a1.143,1.143,0,0,1-1.143,1.143H35.875Zm1.143-2.286H79.041V2.286H21.369V61.339H35.875a1.143,1.143,0,0,1,1.143,1.143V77.407ZM22.935,63.625l11.8,12.112V63.625Zm49.64-7.1H28.05a1.143,1.143,0,1,1,0-2.286H72.575a1.143,1.143,0,0,1,0,2.286Zm0-5.867H28.05a1.143,1.143,0,1,1,0-2.286H72.575a1.143,1.143,0,0,1,0,2.286Zm-8.782-8.17a1.143,1.143,0,0,1-1.143-1.117l-.043-1.892-7.856-1.226a1.142,1.142,0,0,1-.931-1.413l3-11.721a10.724,10.724,0,1,1,18.1-8.612h0a10.709,10.709,0,0,1-3.2,8.535l3.108,14.7a1.143,1.143,0,0,1-.962,1.369l-9.923,1.365A1.009,1.009,0,0,1,63.792,42.491Zm.84-14.395.273,11.945,7.437-1.023L69.716,26.594A10.673,10.673,0,0,1,65.1,28.068C64.943,28.081,64.787,28.089,64.633,28.1Zm-8.287,8.1,6.044.943.149-.64-.2-8.558A10.68,10.68,0,0,1,58.8,26.619ZM64.239,8.935q-.342,0-.687.028A8.44,8.44,0,1,0,72.646,16.7h0A8.453,8.453,0,0,0,64.239,8.935ZM46.416,27.073H28.05a1.143,1.143,0,1,1,0-2.286H46.417a1.143,1.143,0,1,1,0,2.286Zm0-6.919H28.05a1.143,1.143,0,1,1,0-2.286H46.417a1.143,1.143,0,1,1,0,2.286Zm0-7.339H28.05a1.143,1.143,0,1,1,0-2.286H46.417a1.143,1.143,0,1,1,0,2.286Z"
                transform="translate(-19.084)"
              />
            </svg>
          </figure>
        </div>
      </div>
      <div className="col-xs col-sm-9 col-md-9 col-lg-9">
        <div className="px-4">
          <h3>Title</h3>
          <p>
            The title person or closer can access buyer or seller information as
            needed and link policies, tax information etc. to the transaction.
            This enables the agent to have all compliance documents in one
            place.
          </p>
        </div>
      </div>
    </div>
  );
};
const ModalContent5 = () => {
  return (
    <div className="row align-items-center">
      <div className="col-xs col-sm-3 col-md-3 col-lg-3">
        <div
          id="svgImage"
          style={{
            borderRadius: "50%",
            height: "160px",
            width: "160px",
            padding: "2rem",
          }}
        >
          <figure>
            <svg
              stroke="white"
              stroke-width="0.2"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
              width="87.425"
              height={84}
              viewBox="0 0 87.425 84"
            >
              <g id="coordination" transform="translate(0 -10.029)">
                <path
                  id="Path_135"
                  data-name="Path 135"
                  d="M27.642,294.087a1.28,1.28,0,0,0-1.281,1.281v6.02H2.561v-8.543a8.13,8.13,0,0,1,8.121-8.121h.945l-2.62,8.906a1.28,1.28,0,0,0,.312,1.256l4.226,4.328a1.28,1.28,0,0,0,1.832,0l4.226-4.328a1.28,1.28,0,0,0,.312-1.256l-2.62-8.906h.361a1.281,1.281,0,1,0,0-2.561H10.682A10.694,10.694,0,0,0,0,292.844v9.824a1.28,1.28,0,0,0,1.281,1.281H27.642a1.28,1.28,0,0,0,1.281-1.281v-7.3A1.281,1.281,0,0,0,27.642,294.087Zm-13.017-9.364,2.621,8.909-2.785,2.853-2.786-2.853,2.621-8.909Z"
                  transform="translate(0 -225.666)"
                />
                <path
                  id="Path_136"
                  data-name="Path 136"
                  d="M26.355,131.441a12.026,12.026,0,0,0,12.013-12.013v-5.174c0-.214-.006-.427-.017-.638,0-.048-.008-.1-.011-.143-.011-.165-.023-.33-.04-.494-.005-.05-.013-.1-.019-.149-.019-.161-.04-.322-.065-.482-.008-.05-.018-.1-.026-.148-.027-.159-.057-.317-.09-.473-.011-.051-.024-.1-.035-.152-.035-.153-.072-.306-.113-.457-.015-.054-.031-.108-.046-.163-.041-.145-.085-.288-.131-.43-.02-.06-.04-.12-.061-.179-.046-.133-.094-.266-.144-.4-.026-.067-.052-.134-.079-.2q-.073-.18-.152-.357c-.033-.075-.067-.15-.1-.225-.049-.1-.1-.208-.152-.311-.043-.084-.085-.169-.129-.252s-.1-.172-.144-.258-.108-.192-.164-.286c-.037-.062-.077-.122-.115-.182a12.014,12.014,0,0,0-1.223-1.625c-.026-.03-.052-.06-.078-.089-.1-.1-.194-.206-.294-.308-.044-.045-.088-.09-.132-.135-.092-.091-.186-.18-.281-.268q-.085-.079-.172-.157c-.046-.041-.089-.084-.136-.124l-.042-.038-.067-.055-.11-.09-.006-.005c-.054-.045-.108-.09-.162-.133l-.131-.1c-.049-.038-.1-.075-.149-.112l-.015-.011-.1-.074-.155-.111c-.067-.047-.135-.093-.2-.139l-.011-.008-.03-.02c-.06-.04-.12-.08-.184-.122s-.148-.093-.228-.142L32.6,104l-.046-.028c-.047-.029-.093-.058-.139-.084s-.117-.067-.175-.1l-.025-.014-.093-.051-.074-.041-.083-.046-.09-.046-.041-.021-.168-.083-.149-.074c-.139-.066-.279-.129-.419-.19l-.138-.059q-.233-.1-.468-.185l-.034-.012a11.786,11.786,0,0,0-2.856-.658l-.038,0q-.282-.028-.567-.043l-.068,0c-.191-.009-.382-.015-.574-.015a11.988,11.988,0,0,0-6.312,1.79,1.281,1.281,0,0,0,1.348,2.178,9.427,9.427,0,0,1,4.965-1.407c.176,0,.35.006.523.015.07,0,.139.011.208.016.1.008.2.016.3.027s.172.021.258.033.163.023.244.036.184.032.275.049c.075.015.15.031.224.047.092.02.183.04.274.063s.162.044.242.066.162.044.242.069q.236.073.468.159l.1.04c.133.051.266.1.4.162l.108.049q.2.088.388.185c.076.039.154.077.229.117l.05.027q.171.094.337.194l.064.039,0,0q.163.1.322.206l.06.041q.154.105.3.215l.064.048q.148.112.291.229l.056.046c.074.061.146.125.218.189s.123.11.183.166.122.115.182.173.1.1.156.158.124.128.185.194c.045.049.089.1.133.15.062.071.125.141.185.213.038.046.074.093.111.14a9.5,9.5,0,0,1,.57.8c.047.073.094.145.139.219.035.058.067.117.1.175.048.084.1.168.142.253.029.053.055.108.083.162.048.093.095.187.139.282.023.049.045.1.067.149.046.1.09.2.132.309q.027.068.054.136.064.165.122.333c.014.042.029.083.043.125.039.117.074.235.108.354.011.039.023.078.033.117.033.122.063.245.092.368.009.038.018.076.026.114.027.125.05.25.072.377.007.038.014.076.02.115.02.126.037.253.052.381,0,.039.011.078.015.118.014.129.023.259.032.389,0,.038.007.075.009.114q.013.251.014.5v.471a7.967,7.967,0,0,1-4.433-3.321,1.28,1.28,0,0,0-2.025-.161A11.529,11.529,0,0,1,16.9,114.379v-.126a9.434,9.434,0,0,1,1.343-4.859,1.281,1.281,0,1,0-2.2-1.319,12,12,0,0,0-1.709,6.179v5.174A12.026,12.026,0,0,0,26.355,131.441ZM16.9,117.066a14.064,14.064,0,0,0,13.26-3.028,10.479,10.479,0,0,0,5.643,3.327v2.063a9.451,9.451,0,0,1-18.9,0v-2.363Z"
                  transform="translate(-11.894 -76.467)"
                />
                <path
                  id="Path_137"
                  data-name="Path 137"
                  d="M162.606,176.672a1.281,1.281,0,1,0-2.558-.124c-.1,2.072-.654,3.507-1.482,3.839a1.229,1.229,0,0,1-.444.084,1.743,1.743,0,0,1-.29-.02,3.313,3.313,0,0,1-.98-.333h0c-1.812-.91-3.89-3.262-5.746-6.371-.329-.551-.65-1.126-.962-1.72l1.794-.719a4.064,4.064,0,0,0,2.259-5.278h0a4.059,4.059,0,0,0-5.278-2.259l-1.794.719c-1.228-4.289-1.538-8.237-.734-10.484h0a3.317,3.317,0,0,1,.483-.924,1.694,1.694,0,0,1,.2-.216,1.208,1.208,0,0,1,.374-.241c.965-.387,2.659.557,4.42,2.464a32.037,32.037,0,0,1,5.706,9.589,37.776,37.776,0,0,1,2.071,6.987,1.281,1.281,0,0,0,2.518-.469,39.815,39.815,0,0,0-2.211-7.47,34.628,34.628,0,0,0-6.2-10.374c-2.613-2.828-5.189-3.931-7.254-3.1a3.757,3.757,0,0,0-1.153.732,4.194,4.194,0,0,0-.487.529,5.777,5.777,0,0,0-.829,1.523l-6.215,11.762-7.348,2.944a7.242,7.242,0,0,0-.157,13.38q.169.072.34.136l.114.039c.077.027.153.054.23.079.045.014.091.026.137.04.07.021.141.042.212.061.048.013.1.023.146.035.068.016.136.033.205.048.05.011.1.019.151.028.067.013.135.026.2.036.052.008.1.014.155.021.067.009.134.018.2.026s.105.009.158.014.133.011.2.015l.159.006c.066,0,.132,0,.2.005h.04c.046,0,.091,0,.137,0s.112,0,.169,0h.022l1.941,4.845a3.46,3.46,0,1,0,6.425-2.574l-1.792-4.473,3.142-1.259,12.6,4.214a5.777,5.777,0,0,0,1.66.533,4.26,4.26,0,0,0,.63.048h.085a3.771,3.771,0,0,0,1.348-.267C160.817,182.244,162.407,180.765,162.606,176.672Zm-12.737-10.525a1.5,1.5,0,1,1,1.114,2.782l-1.959.784-.058-.132q-.1-.218-.189-.436l-.079-.185c-.088-.209-.174-.417-.258-.626s-.165-.419-.245-.629l-.072-.192q-.084-.223-.165-.447l-.048-.133ZM128.806,176.2a4.687,4.687,0,0,1,2.6-6.086l4.058-1.626a25.881,25.881,0,0,0,3.482,8.691l-4.058,1.626a4.739,4.739,0,0,1-.841.248l-.021.005a4.686,4.686,0,0,1-5.224-2.858Zm10.651,9.41a.9.9,0,0,1-1.661-.02L136,181.117l1.669-.669,1.792,4.473A.894.894,0,0,1,139.457,185.609Zm4.1-9.95a1.28,1.28,0,0,0-.882.026l-1.3.522a23.384,23.384,0,0,1-3.481-8.691l1.3-.522a1.281,1.281,0,0,0,.656-.59l3.653-6.913c0,.022.005.044.008.066.012.109.025.219.038.329.008.07.016.139.025.21.015.121.032.243.05.366.009.061.016.121.025.183.023.155.047.31.073.467,0,.03.009.06.014.09q.047.284.1.572c.006.031.012.063.018.095.03.159.061.318.094.479.013.062.026.124.039.186.027.131.055.262.085.394.016.072.033.145.05.218.028.123.057.247.086.371.019.078.038.156.057.234.03.12.059.239.09.359q.032.123.065.246.047.177.1.354l.07.251q.05.177.1.354.037.128.075.255.053.177.108.356c.026.086.053.171.08.257.038.12.077.24.116.36.028.085.055.171.084.256q.061.183.124.366c.029.084.057.168.087.253.044.127.09.254.136.381.029.08.057.16.087.24.052.141.1.282.158.423.025.066.049.133.075.2q.12.312.245.625t.254.619c.03.071.06.141.09.211.057.133.113.267.171.4.036.083.073.164.109.247.052.119.1.237.158.354.039.087.079.173.119.259.051.111.1.222.154.332.041.088.083.175.125.263q.077.16.154.319c.043.088.087.175.13.262q.077.155.155.308l.133.259q.079.152.158.3l.135.253q.08.149.162.3c.045.082.091.165.137.247.055.1.111.2.167.294.045.079.09.158.136.237.057.1.115.2.172.292.045.076.09.152.135.227.06.1.121.2.181.295.043.07.086.141.13.21.069.109.138.216.207.324l.108.168q.156.238.313.47c.04.059.081.116.121.175.067.1.133.193.2.288.048.069.1.135.146.2s.118.164.177.245.1.14.157.209.112.15.169.223l.047.063Z"
                  transform="translate(-104.41 -116.052)"
                />
                <path
                  id="Path_138"
                  data-name="Path 138"
                  d="M350.987,46.034a6,6,0,0,0-5.855,4.714h-6.647a38.142,38.142,0,0,0-10.346-24.98l4.7-4.7a5.994,5.994,0,1,0-1.811-1.811l-5.59,5.59a1.281,1.281,0,0,0,0,1.811,35.871,35.871,0,0,1,0,50.737,1.286,1.286,0,0,0-.375.9h0v.008h0a1.274,1.274,0,0,0,.191.669,1.29,1.29,0,0,0,.184.233l5.59,5.588a5.992,5.992,0,1,0,1.811-1.811l-4.7-4.7a38.142,38.142,0,0,0,10.347-24.979h6.647a5.994,5.994,0,1,0,5.856-7.275ZM333.645,13.6h0a3.433,3.433,0,1,1,0,4.86l0-.005,0,0a3.433,3.433,0,0,1,0-4.85ZM338.5,85.607h0a3.433,3.433,0,1,1-2.428-1.006A3.41,3.41,0,0,1,338.5,85.607Zm12.486-30.145a3.433,3.433,0,1,1,3.433-3.433A3.437,3.437,0,0,1,350.987,55.462Z"
                  transform="translate(-269.556)"
                />
              </g>
            </svg>
          </figure>
        </div>
      </div>
      <div className="col-xs col-sm-9 col-md-9 col-lg-9">
        <div className="px-4">
          <h3>Transaction Coordinator</h3>
          <p>
            Transaction coordinators can handle many more transactions
            efficiently and error free using the RE-Sure app and track dates and
            deadlines to inform involved parties.
          </p>
        </div>
      </div>
    </div>
  );
};

function ChooseRole() {
  const [iconNum, setIconNum] = useState();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleClick = (num) => {
    setIconNum(num);
    setShow(true);
  };

  return (
    <div>
      <section className="choose-role">
        <div className="container">
          <div className="row">
            <div className="col-xs col-sm-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 text-center mb-4">
              <h2 className="heading text-white">Choose Your Role</h2>
              <p className=" text-white">
                RE-Sure offers unique Features that create a cutting edge
                platform for a variety of roles. Click on your role below for
                more information!
              </p>
            </div>
            <div className="col-12">
              <div className="row text-center my-4">
                <div className="col mb-4" onClick={() => handleClick(1)}>
                  <Link data-bs-toggle="modal" data-bs-target="#role-one">
                    <figure>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="75.502"
                        height="80.035"
                        viewBox="0 0 75.502 80.035"
                      >
                        <g
                          id="real-estate-agent"
                          transform="translate(-13.741 0.807)"
                        >
                          <g
                            id="Group_88"
                            data-name="Group 88"
                            transform="translate(13.741 -0.807)"
                          >
                            <path
                              id="Path_107"
                              data-name="Path 107"
                              d="M87.82,59.362a1.172,1.172,0,0,0-2.009,1.209,12.921,12.921,0,0,1,1.846,6.665V77.689H49.671V63.026a3.507,3.507,0,0,0,1.169.2h0a3.517,3.517,0,0,0,1.747-6.571l-2.014-1.151a12.923,12.923,0,0,1,3.73-1.095c.657,2.518,2.12,6.635,4.811,7.578a4.776,4.776,0,0,0,1.592.27,7.672,7.672,0,0,0,4.673-1.993,7.67,7.67,0,0,0,4.674,1.993,4.784,4.784,0,0,0,1.592-.27c2.691-.944,4.154-5.062,4.811-7.579a12.853,12.853,0,0,1,6,2.453,1.172,1.172,0,0,0,1.4-1.878,15.192,15.192,0,0,0-8-2.993,2.24,2.24,0,0,0-.281-.226l-4.34-2.943V47.347a16.341,16.341,0,0,0,10-11.634,4.792,4.792,0,0,0,1.8.352c3.447,0,5.251-3.912,5.251-7.777,0-3.438-1.366-5.886-3.594-6.677a12.32,12.32,0,0,0,.356-6.64c1.146-2.348,1.318-4.455.512-6.27a7.32,7.32,0,0,0-3.835-3.532,5.134,5.134,0,0,0-.909-3.638C80.378.872,79.02-1.131,66.98.851a1.172,1.172,0,1,0,.381,2.314c8.364-1.377,11.15-.694,11.528-.31a2.661,2.661,0,0,1,.39,2.518,1.133,1.133,0,0,0-.041,1.01,1.163,1.163,0,0,0,.8.656c.025.006,2.535.693,3.389,2.614.543,1.222.33,2.77-.635,4.6a1.171,1.171,0,0,0-.11.786c.7,3.377.111,5.426-.7,6.887l-.018.033a14.439,14.439,0,0,1-.972,1.469,8.113,8.113,0,0,0-.83,1.3,9.532,9.532,0,0,0-.564,2.042,7.773,7.773,0,0,1-1.332-1.409c.332-3.273.527-8.851-1.657-10.786a2.914,2.914,0,0,0-2.689-.641c-.947.217-1.768.422-2.493.6a22.328,22.328,0,0,1-6.182.942,22.33,22.33,0,0,1-6.182-.942c-.725-.18-1.546-.385-2.492-.6a2.914,2.914,0,0,0-2.689.641C51.7,16.513,51.9,22.113,52.231,25.383A7.262,7.262,0,0,1,51,26.8a13.843,13.843,0,0,0-.668-2.071c-.058-.124-.116-.246-.175-.368a8.461,8.461,0,0,1-.952-3.731,1.248,1.248,0,0,0-.019-.15,19.35,19.35,0,0,1,.112-6.758c.934-4.487,3.577-7.311,7.854-8.393,1.638-.414,3.272-.8,4.856-1.138A1.172,1.172,0,1,0,61.516,1.9c-1.612.347-3.273.736-4.938,1.157C51.419,4.358,48.106,7.892,47,13.274a21.651,21.651,0,0,0-.126,7.57c.013.193.029.375.046.552-2.729.423-4.449,3.033-4.449,6.891s1.8,7.777,5.251,7.777a4.792,4.792,0,0,0,1.788-.347A16.285,16.285,0,0,0,59.519,47.374v1.451l-4.34,2.943a2.254,2.254,0,0,0-.281.225,15.259,15.259,0,0,0-6.728,2.14l-12-6.855a3.531,3.531,0,0,0-3.49,0l-.6.343v-.667a1.8,1.8,0,0,0,1.563-1.781V41.735a1.8,1.8,0,0,0-1.8-1.8H20.6a1.8,1.8,0,0,0-1.8,1.8v3.439a1.8,1.8,0,0,0,1.563,1.781v7.366l-4.089,2.337a3.52,3.52,0,0,0,1.75,6.573,3.476,3.476,0,0,0,1.166-.2v4.958a1.172,1.172,0,1,0,2.345,0V61.753l12.9-7.369,12.9,7.369V77.689H42.342V63.854a1.8,1.8,0,0,0-1.8-1.8H28.351a1.8,1.8,0,0,0-1.8,1.8V77.689h-5.02v-3.4a1.172,1.172,0,0,0-2.345,0v4.575a1.172,1.172,0,0,0,1.172,1.172H88.829A1.172,1.172,0,0,0,90,78.861V67.236A15.268,15.268,0,0,0,87.82,59.362Zm-16.95.416c-1.282.449-2.677-.315-3.595-1a11.067,11.067,0,0,0,3.854-7.193l3.1,2.1c-.837,3.285-2.151,5.676-3.355,6.1ZM85.95,28.288c0,2.67-1.087,5.432-2.906,5.432a2.6,2.6,0,0,1-1.45-.464c.024-.358.037-.719.037-1.084V29.055a16.1,16.1,0,0,1,.659-3.339,6.847,6.847,0,0,1,.6-.909c.226-.312.481-.662.738-1.062,1.7.4,2.322,2.531,2.322,4.543ZM47.719,33.72c-1.819,0-2.906-2.762-2.906-5.432,0-2.1.677-4.33,2.545-4.584a11.548,11.548,0,0,0,.687,1.67c.055.114.109.227.162.341a23.054,23.054,0,0,1,.925,3.384v3.13c0,.345.012.688.033,1.03a2.6,2.6,0,0,1-1.446.462Zm3.758-1.491v-2.7c3.259-2.72,3.142-3.859,3.1-4.243-.464-4.412-.109-8.1.863-8.956a.592.592,0,0,1,.609-.11c.925.212,1.735.414,2.45.592a24.768,24.768,0,0,0,6.749,1.012A24.767,24.767,0,0,0,72,16.811c.715-.178,1.525-.38,2.45-.592a.592.592,0,0,1,.609.11c.972.861,1.327,4.544.862,8.956-.041.391-.16,1.549,3.368,4.279v2.608A13.949,13.949,0,0,1,65.353,46.105,13.878,13.878,0,0,1,51.476,32.229ZM65.353,48.45a16.27,16.27,0,0,0,3.545-.39v2.2a9.067,9.067,0,0,1-3.518,7,8.958,8.958,0,0,1-3.517-6.921V48.075A16.356,16.356,0,0,0,65.353,48.45Zm-5.721,3.131a11.068,11.068,0,0,0,3.854,7.193c-.918.69-2.313,1.453-3.595,1-1.2-.422-2.518-2.813-3.354-6.1Zm-38.49-9.3H31.3v2.345H21.142Zm1.563,4.69H29.74v1.99l-7.034,4.02Zm11.142,5.044L19.806,60.039l-.013.007-1.195.683a1.172,1.172,0,0,1-1.163-2.036l16.414-9.379a1.177,1.177,0,0,1,1.163,0l16.413,9.379a1.173,1.173,0,0,1-.584,2.19,1.154,1.154,0,0,1-.579-.155l-1.194-.682-.014-.008L35.012,52.015a1.173,1.173,0,0,0-1.163,0ZM28.9,77.689V64.4H40V77.689Z"
                              transform="translate(-14.5 0.002)"
                            />
                            <path
                              id="Path_108"
                              data-name="Path 108"
                              d="M316.5,421.852a3.673,3.673,0,1,0,3.673-3.673A3.678,3.678,0,0,0,316.5,421.852Zm5,0a1.329,1.329,0,1,1-1.329-1.329A1.33,1.33,0,0,1,321.5,421.852Z"
                              transform="translate(-269.289 -352.81)"
                            />
                            <path
                              id="Path_109"
                              data-name="Path 109"
                              d="M327.372,218.7a4.255,4.255,0,0,0,2.468,0,1.172,1.172,0,0,0-.592-2.269,1.981,1.981,0,0,1-1.284,0,1.172,1.172,0,1,0-.592,2.269Z"
                              transform="translate(-277.725 -182.569)"
                            />
                            <path
                              id="Path_110"
                              data-name="Path 110"
                              d="M287.3,138.126a1.172,1.172,0,0,0,.592-2.269,7.881,7.881,0,0,0-4.627,0,1.172,1.172,0,1,0,.592,2.269,5.542,5.542,0,0,1,3.443,0Z"
                              transform="translate(-240.513 -114.327)"
                            />
                            <path
                              id="Path_111"
                              data-name="Path 111"
                              d="M358.259,138.126a5.542,5.542,0,0,1,3.443,0,1.172,1.172,0,0,0,.592-2.269,7.881,7.881,0,0,0-4.627,0,1.172,1.172,0,0,0,.592,2.269Z"
                              transform="translate(-303.284 -114.327)"
                            />
                            <path
                              id="Path_112"
                              data-name="Path 112"
                              d="M321.282,243.533a1.172,1.172,0,0,0-1.14-2.049,4.921,4.921,0,0,1-4.753,0,1.172,1.172,0,1,0-1.14,2.049,7.281,7.281,0,0,0,7.034,0Z"
                              transform="translate(-266.884 -203.61)"
                            />
                            <path
                              id="Path_113"
                              data-name="Path 113"
                              d="M291.669,172.418a1.172,1.172,0,0,0-1.172,1.172v.938a1.172,1.172,0,1,0,2.345,0v-.938A1.172,1.172,0,0,0,291.669,172.418Z"
                              transform="translate(-247.354 -145.466)"
                            />
                            <path
                              id="Path_114"
                              data-name="Path 114"
                              d="M375.67,172.418a1.172,1.172,0,0,0-1.172,1.172v.938a1.172,1.172,0,1,0,2.345,0v-.938A1.172,1.172,0,0,0,375.67,172.418Z"
                              transform="translate(-318.224 -145.466)"
                            />
                          </g>
                        </g>
                      </svg>
                    </figure>
                    <h3 className=" text-white">Real Estate Agent</h3>
                  </Link>
                </div>

                <div className="col mb-4" onClick={() => handleClick(2)}>
                  <Link data-bs-toggle="modal" data-bs-target="#role-two">
                    <figure>
                      <svg
                        id="value"
                        xmlns="http://www.w3.org/2000/svg"
                        width="79.888"
                        height="79.928"
                        viewBox="0 0 79.888 79.928"
                      >
                        <path
                          id="Path_47"
                          data-name="Path 47"
                          d="M96.035,285.438l-.41.221a5.654,5.654,0,0,0-6.718-1.682l-.023.012-.969.522a7.357,7.357,0,0,0-8.425-.761l-5.217,2.837H67.332a10.028,10.028,0,0,1-4.34-.995l-.955-.462a16.382,16.382,0,0,0-17.049,1.665c-.023.017-.045.035-.066.054L42.616,288.9a8,8,0,0,1-3.018,1.682l-1.309-4.3a1.038,1.038,0,0,0-.993-.735H26.146a1.038,1.038,0,0,0-1.03,1.164l3.717,30.475a1.038,1.038,0,0,0,1.03.912H46.587a1.038,1.038,0,0,0,.993-1.341l-2.2-7.21,6.843-4.325a4.118,4.118,0,0,1,3-.389l.065.014,13.919,2.563a18.012,18.012,0,0,0,11.13-1.572,1.011,1.011,0,0,0,.127-.074l24.075-16.53a1.038,1.038,0,0,0,.3-1.391A6.608,6.608,0,0,0,96.035,285.438Zm-6.179.385a3.545,3.545,0,0,1,3.876.857L84.6,291.605l-.536.282a7.916,7.916,0,0,0-1.25-2.272Zm-9.361-.257.025-.014a5.279,5.279,0,0,1,5.369.05l-4.642,2.5a7.887,7.887,0,0,0-2.965-1.334ZM30.781,316.025l-3.463-28.4h9.208l8.658,28.4Zm48.575-12.011a15.922,15.922,0,0,1-9.771,1.358L55.7,302.815a6.189,6.189,0,0,0-4.513.612l-.048.029-6.386,4.037L40.2,292.571a10.081,10.081,0,0,0,3.792-2.12l2.273-2.024A14.313,14.313,0,0,1,61.132,287l.955.462a12.116,12.116,0,0,0,5.244,1.2h9.26a5.856,5.856,0,0,1,5.743,4.756l-6.711-.3a40.19,40.19,0,0,0-7.3.338,1.038,1.038,0,1,0,.285,2.056,38.054,38.054,0,0,1,6.925-.32l7.9.357h.047a1.038,1.038,0,0,0,1.038-1.038c0-.168-.007-.334-.017-.5l1.083-.571,11.444-6.172a4.535,4.535,0,0,1,5.457.875Z"
                          transform="translate(-25.108 -238.173)"
                        />
                        <path
                          id="Path_48"
                          data-name="Path 48"
                          d="M76.974,434.566a3.268,3.268,0,1,0,3.268-3.268A3.268,3.268,0,0,0,76.974,434.566Zm3.268-1.192a1.192,1.192,0,1,1-1.192,1.192,1.192,1.192,0,0,1,1.192-1.192Z"
                          transform="translate(-68.001 -361.008)"
                        />
                        <path
                          id="Path_49"
                          data-name="Path 49"
                          d="M226.292,36.288v-3.42a7.879,7.879,0,1,0-15.758,0v3.42a7.879,7.879,0,1,0,15.758,0Zm-13.682,0v-3.42a5.8,5.8,0,1,1,11.606,0v3.42a5.8,5.8,0,1,1-11.606,0Z"
                          transform="translate(-178.456 -24.989)"
                        />
                        <path
                          id="Path_50"
                          data-name="Path 50"
                          d="M89.491,159.567h25.4a1.038,1.038,0,0,0,1.038-1.038v-2.383h17.388a1.038,1.038,0,0,0,1.038-1.038v-6.737a7.78,7.78,0,0,0-7.285-7.76A1.212,1.212,0,0,0,126,141.2a4.763,4.763,0,0,1-7.515-.184,1.038,1.038,0,0,0-.861-.421,7.7,7.7,0,0,0-3.818,1.114,8.726,8.726,0,0,0-6.09-3.02,1.262,1.262,0,0,0-1.07.623,5.589,5.589,0,0,1-8.819-.215,1.035,1.035,0,0,0-.861-.421,8.687,8.687,0,0,0-6.028,2.63c-.131.134-.256.273-.377.414a7.718,7.718,0,0,0-3.539-1.111,1.214,1.214,0,0,0-1.069.591,4.763,4.763,0,0,1-7.515-.184,1.041,1.041,0,0,0-.861-.421A7.777,7.777,0,0,0,70,148.371v6.737a1.038,1.038,0,0,0,1.038,1.038H88.453v2.383A1.038,1.038,0,0,0,89.491,159.567Zm27.691-16.86a6.84,6.84,0,0,0,10.241.027,5.707,5.707,0,0,1,4.855,5.637v5.7h-16.35v-6.659a8.684,8.684,0,0,0-.959-3.974A5.61,5.61,0,0,1,117.182,142.707ZM96.52,140.786a7.666,7.666,0,0,0,11.579.027,6.667,6.667,0,0,1,5.754,6.6v10.079H90.529V147.411A6.706,6.706,0,0,1,96.52,140.786ZM72.076,154.07v-5.7a5.74,5.74,0,0,1,5.061-5.664,6.84,6.84,0,0,0,10.24.026,5.663,5.663,0,0,1,2.026.715,8.7,8.7,0,0,0-.949,3.963v6.659Z"
                          transform="translate(-62.234 -119.01)"
                        />
                        <path
                          id="Path_51"
                          data-name="Path 51"
                          d="M345.181,60.28V57.286a7.026,7.026,0,1,0-14.051,0V60.28a7.026,7.026,0,1,0,14.051,0Zm-11.976,0V57.286a4.95,4.95,0,0,1,9.9,0V60.28a4.95,4.95,0,0,1-9.9,0Z"
                          transform="translate(-278.189 -45.888)"
                        />
                        <path
                          id="Path_52"
                          data-name="Path 52"
                          d="M113.7,60.28V57.286a7.026,7.026,0,1,0-14.051,0V60.28a7.026,7.026,0,1,0,14.051,0Zm-11.976,0V57.286a4.95,4.95,0,0,1,9.9,0V60.28a4.95,4.95,0,0,1-9.9,0Z"
                          transform="translate(-86.751 -45.888)"
                        />
                      </svg>
                    </figure>
                    <h3 className=" text-white">Customer</h3>
                  </Link>
                </div>

                <div className="col mb-4" onClick={() => handleClick(3)}>
                  <Link data-bs-toggle="modal">
                    <figure>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="79.766"
                        height="79.766"
                        viewBox="0 0 79.766 79.766"
                      >
                        <g id="XMLID_1248_" transform="translate(0 0)">
                          <g id="XMLID_871_" transform="translate(0 0)">
                            <path
                              id="XMLID_874_"
                              d="M80.852,153.241h34.021a1.558,1.558,0,1,0,0-3.116H80.852a1.558,1.558,0,1,0,0,3.116Z"
                              transform="translate(-66.941 -126.737)"
                            />
                            <path
                              id="XMLID_887_"
                              d="M132.392,97.241h17.962a1.558,1.558,0,1,0,0-3.116H132.392a1.558,1.558,0,0,0,0,3.116Z"
                              transform="translate(-110.451 -79.461)"
                            />
                            <path
                              id="XMLID_917_"
                              d="M80.852,209.241h34.021a1.558,1.558,0,1,0,0-3.116H80.852a1.558,1.558,0,1,0,0,3.116Z"
                              transform="translate(-66.941 -174.012)"
                            />
                            <path
                              id="XMLID_919_"
                              d="M84.461,310.969a1.909,1.909,0,0,1,2.051,1.718,1.558,1.558,0,1,0,3.116,0,4.89,4.89,0,0,0-3.609-4.609v-.217a1.558,1.558,0,0,0-3.116,0v.217a4.89,4.89,0,0,0-3.61,4.609,5.015,5.015,0,0,0,5.167,4.834,1.745,1.745,0,1,1-2.052,1.718,1.558,1.558,0,1,0-3.116,0,4.89,4.89,0,0,0,3.61,4.609v.217a1.558,1.558,0,0,0,3.116,0v-.217a4.89,4.89,0,0,0,3.609-4.609,5.014,5.014,0,0,0-5.167-4.834,1.745,1.745,0,1,1,0-3.436Z"
                              transform="translate(-66.941 -258.584)"
                            />
                            <path
                              id="XMLID_920_"
                              d="M97.862,262.125H80.852a1.558,1.558,0,1,0,0,3.116h17.01a1.558,1.558,0,0,0,0-3.116Z"
                              transform="translate(-66.941 -221.288)"
                            />
                            <path
                              id="XMLID_1032_"
                              d="M79.309,53.626,61.382,35.7V1.558A1.558,1.558,0,0,0,59.824,0H1.558A1.558,1.558,0,0,0,0,1.558v76.65a1.558,1.558,0,0,0,1.558,1.558h73.6a1.558,1.558,0,0,0,1.558-1.558V56.286h1.495a1.558,1.558,0,0,0,1.1-2.66ZM3.116,3.116h55.15v29.5a1.555,1.555,0,0,0-1.988.178L35.45,53.626a1.558,1.558,0,0,0,1.1,2.66h1.5V76.65H3.116ZM51.927,76.65V63.141H62.832V76.65Zm21.67,0H65.948V61.583a1.558,1.558,0,0,0-1.558-1.558H50.369a1.558,1.558,0,0,0-1.558,1.558V76.65H41.162V56.286h9.207a1.558,1.558,0,1,0,0-3.116H40.312L57.379,36.1,74.446,53.17H64.39a1.558,1.558,0,0,0,0,3.116H73.6V76.65Z"
                              transform="translate(0 0)"
                            />
                            <path
                              id="XMLID_1035_"
                              d="M359.868,341.29a1.559,1.559,0,1,0,1.1.456A1.566,1.566,0,0,0,359.868,341.29Z"
                              transform="translate(-302.488 -288.12)"
                            />
                          </g>
                        </g>
                      </svg>
                    </figure>
                    <h3 className=" text-white">Mortgage Broker/Lender</h3>
                  </Link>
                </div>
                <div className="col mb-4" onClick={() => handleClick(4)}>
                  <Link data-bs-toggle="modal" data-bs-target="#role-four">
                    <figure>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="62.245"
                        height="79.693"
                        viewBox="0 0 62.245 79.693"
                      >
                        <path
                          id="award"
                          d="M35.875,79.693a1.128,1.128,0,0,1-.136-.008h-.012a1.044,1.044,0,0,1-.14-.027h0a1.145,1.145,0,0,1-.521-.3l0,0,0,0,0,0L19.407,63.28l0,0h0l0,0a1.142,1.142,0,0,1-.281-.5h0v0a.006.006,0,0,0,0,0,1.128,1.128,0,0,1-.03-.166h0V62.6h0a1.215,1.215,0,0,1-.006-.123V1.143A1.143,1.143,0,0,1,20.227,0H80.186a1.143,1.143,0,0,1,1.143,1.143V78.55a1.143,1.143,0,0,1-1.143,1.143H35.875Zm1.143-2.286H79.041V2.286H21.369V61.339H35.875a1.143,1.143,0,0,1,1.143,1.143V77.407ZM22.935,63.625l11.8,12.112V63.625Zm49.64-7.1H28.05a1.143,1.143,0,1,1,0-2.286H72.575a1.143,1.143,0,0,1,0,2.286Zm0-5.867H28.05a1.143,1.143,0,1,1,0-2.286H72.575a1.143,1.143,0,0,1,0,2.286Zm-8.782-8.17a1.143,1.143,0,0,1-1.143-1.117l-.043-1.892-7.856-1.226a1.142,1.142,0,0,1-.931-1.413l3-11.721a10.724,10.724,0,1,1,18.1-8.612h0a10.709,10.709,0,0,1-3.2,8.535l3.108,14.7a1.143,1.143,0,0,1-.962,1.369l-9.923,1.365A1.009,1.009,0,0,1,63.792,42.491Zm.84-14.395.273,11.945,7.437-1.023L69.716,26.594A10.673,10.673,0,0,1,65.1,28.068C64.943,28.081,64.787,28.089,64.633,28.1Zm-8.287,8.1,6.044.943.149-.64-.2-8.558A10.68,10.68,0,0,1,58.8,26.619ZM64.239,8.935q-.342,0-.687.028A8.44,8.44,0,1,0,72.646,16.7h0A8.453,8.453,0,0,0,64.239,8.935ZM46.416,27.073H28.05a1.143,1.143,0,1,1,0-2.286H46.417a1.143,1.143,0,1,1,0,2.286Zm0-6.919H28.05a1.143,1.143,0,1,1,0-2.286H46.417a1.143,1.143,0,1,1,0,2.286Zm0-7.339H28.05a1.143,1.143,0,1,1,0-2.286H46.417a1.143,1.143,0,1,1,0,2.286Z"
                          transform="translate(-19.084)"
                        />
                      </svg>
                    </figure>
                    <h3 className=" text-white">Title</h3>
                  </Link>
                </div>
                <div className="col mb-4" onClick={() => handleClick(5)}>
                  <Link data-bs-toggle="modal" data-bs-target="#role-five">
                    <figure>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="87.425"
                        height={84}
                        viewBox="0 0 87.425 84"
                      >
                        <g id="coordination" transform="translate(0 -10.029)">
                          <path
                            id="Path_135"
                            data-name="Path 135"
                            d="M27.642,294.087a1.28,1.28,0,0,0-1.281,1.281v6.02H2.561v-8.543a8.13,8.13,0,0,1,8.121-8.121h.945l-2.62,8.906a1.28,1.28,0,0,0,.312,1.256l4.226,4.328a1.28,1.28,0,0,0,1.832,0l4.226-4.328a1.28,1.28,0,0,0,.312-1.256l-2.62-8.906h.361a1.281,1.281,0,1,0,0-2.561H10.682A10.694,10.694,0,0,0,0,292.844v9.824a1.28,1.28,0,0,0,1.281,1.281H27.642a1.28,1.28,0,0,0,1.281-1.281v-7.3A1.281,1.281,0,0,0,27.642,294.087Zm-13.017-9.364,2.621,8.909-2.785,2.853-2.786-2.853,2.621-8.909Z"
                            transform="translate(0 -225.666)"
                          />
                          <path
                            id="Path_136"
                            data-name="Path 136"
                            d="M26.355,131.441a12.026,12.026,0,0,0,12.013-12.013v-5.174c0-.214-.006-.427-.017-.638,0-.048-.008-.1-.011-.143-.011-.165-.023-.33-.04-.494-.005-.05-.013-.1-.019-.149-.019-.161-.04-.322-.065-.482-.008-.05-.018-.1-.026-.148-.027-.159-.057-.317-.09-.473-.011-.051-.024-.1-.035-.152-.035-.153-.072-.306-.113-.457-.015-.054-.031-.108-.046-.163-.041-.145-.085-.288-.131-.43-.02-.06-.04-.12-.061-.179-.046-.133-.094-.266-.144-.4-.026-.067-.052-.134-.079-.2q-.073-.18-.152-.357c-.033-.075-.067-.15-.1-.225-.049-.1-.1-.208-.152-.311-.043-.084-.085-.169-.129-.252s-.1-.172-.144-.258-.108-.192-.164-.286c-.037-.062-.077-.122-.115-.182a12.014,12.014,0,0,0-1.223-1.625c-.026-.03-.052-.06-.078-.089-.1-.1-.194-.206-.294-.308-.044-.045-.088-.09-.132-.135-.092-.091-.186-.18-.281-.268q-.085-.079-.172-.157c-.046-.041-.089-.084-.136-.124l-.042-.038-.067-.055-.11-.09-.006-.005c-.054-.045-.108-.09-.162-.133l-.131-.1c-.049-.038-.1-.075-.149-.112l-.015-.011-.1-.074-.155-.111c-.067-.047-.135-.093-.2-.139l-.011-.008-.03-.02c-.06-.04-.12-.08-.184-.122s-.148-.093-.228-.142L32.6,104l-.046-.028c-.047-.029-.093-.058-.139-.084s-.117-.067-.175-.1l-.025-.014-.093-.051-.074-.041-.083-.046-.09-.046-.041-.021-.168-.083-.149-.074c-.139-.066-.279-.129-.419-.19l-.138-.059q-.233-.1-.468-.185l-.034-.012a11.786,11.786,0,0,0-2.856-.658l-.038,0q-.282-.028-.567-.043l-.068,0c-.191-.009-.382-.015-.574-.015a11.988,11.988,0,0,0-6.312,1.79,1.281,1.281,0,0,0,1.348,2.178,9.427,9.427,0,0,1,4.965-1.407c.176,0,.35.006.523.015.07,0,.139.011.208.016.1.008.2.016.3.027s.172.021.258.033.163.023.244.036.184.032.275.049c.075.015.15.031.224.047.092.02.183.04.274.063s.162.044.242.066.162.044.242.069q.236.073.468.159l.1.04c.133.051.266.1.4.162l.108.049q.2.088.388.185c.076.039.154.077.229.117l.05.027q.171.094.337.194l.064.039,0,0q.163.1.322.206l.06.041q.154.105.3.215l.064.048q.148.112.291.229l.056.046c.074.061.146.125.218.189s.123.11.183.166.122.115.182.173.1.1.156.158.124.128.185.194c.045.049.089.1.133.15.062.071.125.141.185.213.038.046.074.093.111.14a9.5,9.5,0,0,1,.57.8c.047.073.094.145.139.219.035.058.067.117.1.175.048.084.1.168.142.253.029.053.055.108.083.162.048.093.095.187.139.282.023.049.045.1.067.149.046.1.09.2.132.309q.027.068.054.136.064.165.122.333c.014.042.029.083.043.125.039.117.074.235.108.354.011.039.023.078.033.117.033.122.063.245.092.368.009.038.018.076.026.114.027.125.05.25.072.377.007.038.014.076.02.115.02.126.037.253.052.381,0,.039.011.078.015.118.014.129.023.259.032.389,0,.038.007.075.009.114q.013.251.014.5v.471a7.967,7.967,0,0,1-4.433-3.321,1.28,1.28,0,0,0-2.025-.161A11.529,11.529,0,0,1,16.9,114.379v-.126a9.434,9.434,0,0,1,1.343-4.859,1.281,1.281,0,1,0-2.2-1.319,12,12,0,0,0-1.709,6.179v5.174A12.026,12.026,0,0,0,26.355,131.441ZM16.9,117.066a14.064,14.064,0,0,0,13.26-3.028,10.479,10.479,0,0,0,5.643,3.327v2.063a9.451,9.451,0,0,1-18.9,0v-2.363Z"
                            transform="translate(-11.894 -76.467)"
                          />
                          <path
                            id="Path_137"
                            data-name="Path 137"
                            d="M162.606,176.672a1.281,1.281,0,1,0-2.558-.124c-.1,2.072-.654,3.507-1.482,3.839a1.229,1.229,0,0,1-.444.084,1.743,1.743,0,0,1-.29-.02,3.313,3.313,0,0,1-.98-.333h0c-1.812-.91-3.89-3.262-5.746-6.371-.329-.551-.65-1.126-.962-1.72l1.794-.719a4.064,4.064,0,0,0,2.259-5.278h0a4.059,4.059,0,0,0-5.278-2.259l-1.794.719c-1.228-4.289-1.538-8.237-.734-10.484h0a3.317,3.317,0,0,1,.483-.924,1.694,1.694,0,0,1,.2-.216,1.208,1.208,0,0,1,.374-.241c.965-.387,2.659.557,4.42,2.464a32.037,32.037,0,0,1,5.706,9.589,37.776,37.776,0,0,1,2.071,6.987,1.281,1.281,0,0,0,2.518-.469,39.815,39.815,0,0,0-2.211-7.47,34.628,34.628,0,0,0-6.2-10.374c-2.613-2.828-5.189-3.931-7.254-3.1a3.757,3.757,0,0,0-1.153.732,4.194,4.194,0,0,0-.487.529,5.777,5.777,0,0,0-.829,1.523l-6.215,11.762-7.348,2.944a7.242,7.242,0,0,0-.157,13.38q.169.072.34.136l.114.039c.077.027.153.054.23.079.045.014.091.026.137.04.07.021.141.042.212.061.048.013.1.023.146.035.068.016.136.033.205.048.05.011.1.019.151.028.067.013.135.026.2.036.052.008.1.014.155.021.067.009.134.018.2.026s.105.009.158.014.133.011.2.015l.159.006c.066,0,.132,0,.2.005h.04c.046,0,.091,0,.137,0s.112,0,.169,0h.022l1.941,4.845a3.46,3.46,0,1,0,6.425-2.574l-1.792-4.473,3.142-1.259,12.6,4.214a5.777,5.777,0,0,0,1.66.533,4.26,4.26,0,0,0,.63.048h.085a3.771,3.771,0,0,0,1.348-.267C160.817,182.244,162.407,180.765,162.606,176.672Zm-12.737-10.525a1.5,1.5,0,1,1,1.114,2.782l-1.959.784-.058-.132q-.1-.218-.189-.436l-.079-.185c-.088-.209-.174-.417-.258-.626s-.165-.419-.245-.629l-.072-.192q-.084-.223-.165-.447l-.048-.133ZM128.806,176.2a4.687,4.687,0,0,1,2.6-6.086l4.058-1.626a25.881,25.881,0,0,0,3.482,8.691l-4.058,1.626a4.739,4.739,0,0,1-.841.248l-.021.005a4.686,4.686,0,0,1-5.224-2.858Zm10.651,9.41a.9.9,0,0,1-1.661-.02L136,181.117l1.669-.669,1.792,4.473A.894.894,0,0,1,139.457,185.609Zm4.1-9.95a1.28,1.28,0,0,0-.882.026l-1.3.522a23.384,23.384,0,0,1-3.481-8.691l1.3-.522a1.281,1.281,0,0,0,.656-.59l3.653-6.913c0,.022.005.044.008.066.012.109.025.219.038.329.008.07.016.139.025.21.015.121.032.243.05.366.009.061.016.121.025.183.023.155.047.31.073.467,0,.03.009.06.014.09q.047.284.1.572c.006.031.012.063.018.095.03.159.061.318.094.479.013.062.026.124.039.186.027.131.055.262.085.394.016.072.033.145.05.218.028.123.057.247.086.371.019.078.038.156.057.234.03.12.059.239.09.359q.032.123.065.246.047.177.1.354l.07.251q.05.177.1.354.037.128.075.255.053.177.108.356c.026.086.053.171.08.257.038.12.077.24.116.36.028.085.055.171.084.256q.061.183.124.366c.029.084.057.168.087.253.044.127.09.254.136.381.029.08.057.16.087.24.052.141.1.282.158.423.025.066.049.133.075.2q.12.312.245.625t.254.619c.03.071.06.141.09.211.057.133.113.267.171.4.036.083.073.164.109.247.052.119.1.237.158.354.039.087.079.173.119.259.051.111.1.222.154.332.041.088.083.175.125.263q.077.16.154.319c.043.088.087.175.13.262q.077.155.155.308l.133.259q.079.152.158.3l.135.253q.08.149.162.3c.045.082.091.165.137.247.055.1.111.2.167.294.045.079.09.158.136.237.057.1.115.2.172.292.045.076.09.152.135.227.06.1.121.2.181.295.043.07.086.141.13.21.069.109.138.216.207.324l.108.168q.156.238.313.47c.04.059.081.116.121.175.067.1.133.193.2.288.048.069.1.135.146.2s.118.164.177.245.1.14.157.209.112.15.169.223l.047.063Z"
                            transform="translate(-104.41 -116.052)"
                          />
                          <path
                            id="Path_138"
                            data-name="Path 138"
                            d="M350.987,46.034a6,6,0,0,0-5.855,4.714h-6.647a38.142,38.142,0,0,0-10.346-24.98l4.7-4.7a5.994,5.994,0,1,0-1.811-1.811l-5.59,5.59a1.281,1.281,0,0,0,0,1.811,35.871,35.871,0,0,1,0,50.737,1.286,1.286,0,0,0-.375.9h0v.008h0a1.274,1.274,0,0,0,.191.669,1.29,1.29,0,0,0,.184.233l5.59,5.588a5.992,5.992,0,1,0,1.811-1.811l-4.7-4.7a38.142,38.142,0,0,0,10.347-24.979h6.647a5.994,5.994,0,1,0,5.856-7.275ZM333.645,13.6h0a3.433,3.433,0,1,1,0,4.86l0-.005,0,0a3.433,3.433,0,0,1,0-4.85ZM338.5,85.607h0a3.433,3.433,0,1,1-2.428-1.006A3.41,3.41,0,0,1,338.5,85.607Zm12.486-30.145a3.433,3.433,0,1,1,3.433-3.433A3.437,3.437,0,0,1,350.987,55.462Z"
                            transform="translate(-269.556)"
                          />
                        </g>
                      </svg>
                    </figure>
                    <h3 className=" text-white">Transaction Coordinator</h3>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
        show={show}
        onHide={handleClose}
        style={{
          width: "100%",
        }}
      >
        <Modal.Body>
          <div
            className="col mb-4"
            style={{
              padding: "2rem",
              display: "flex",
              width: "100%",
            }}
          >
            <div
              id="svgImage"
              style={{
                // backgroundColor: "rgb(0,119,216)",
                borderRadius: "50%",
                height: "29vh",
                width: "24%",
                paddingLeft: "2.5rem",
                paddingRight: "3rem",
                marginRight: "2rem",
                paddingTop: "2.5rem",
              }}
            >
              {iconNum === 1
                ? icon1
                : iconNum === 2
                ? icon2
                : iconNum === 3
                ? icon3
                : iconNum === 4
                ? icon4
                : iconNum === 5
                ? icon5
                : "no image available"}
            </div>

            <div style={{ width: "70%" }}>
              <h4>{heading.current}</h4>
              {text?.current}
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
        show={show}
        onHide={handleClose}
        style={{
          width: "100%",
          padding: 0,
          zIndex: 10000,
        }}
      >
        <Modal.Body
          style={{
            padding: "2rem",
          }}
        >
          {/* <div
            className="col mb-4"
            style={{
              padding: 0,
              paddingRight: "2rem",
              display: "flex",
              width: "100%",
            }}
          >
            <div
              // id="svgImage"
              style={{
                backgroundColor: "rgb(0,119,216)",
                width: "40%",
                // height: "100%",
                backgroundImage: `url(${popupbg})`,
                margin: "-16px",
                Maxheight: "361px",
                borderRadius: "8px",
                marginBottom: "-40px",
                marginRight:"0px",
                display:"flex",
                justifyContent:"center",
                alignContent:"center",
                paddingTop:'-10px'
              }}
            >
              <img src={webappslider1} 
              alt="computer Image" 
              style={{
                margin:'auto',
                width:'100%',
                // height:
              }}
              />
              
            </div>
            <div 
            style={{ width: "60%",
            marginLeft:"2rem"
          }}
            >
              <div style={{
                // backgroundColor: "rgb(0,119,216)",
              }}>
            {iconNum === 1
                ? icon1
                : iconNum === 2
                ? icon2
                : iconNum === 3
                ? icon3
                : iconNum === 4
                ? icon4
                : iconNum === 5
                ? icon5
                : "no image available"}</div>
              <h4>{heading.current}</h4>
              <p>Automated Guidance and Tracking of Transactions to Ensure Regulatory and Legal Compliance.</p>
              <ul>
                <li>Regulatory Compliance (DORA) & On Demand Reports.</li>
                <li>Pre-packed Transaction Documentation.</li>
              </ul>
              {textForIcon?.current}
            </div>
          </div> */}
          {iconNum === 1 ? (
            <ModalContent1 />
          ) : iconNum === 2 ? (
            <ModalContent2 />
          ) : iconNum === 3 ? (
            <ModalContent3 />
          ) : iconNum === 4 ? (
            <ModalContent4 />
          ) : iconNum === 5 ? (
            <ModalContent5 />
          ) : (
            "no content available"
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ChooseRole;
